export default "__VITE_ASSET__55437b15__"